import { render, staticRenderFns } from "./ClientDuplicateConfirmation.vue?vue&type=template&id=6457ac54&scoped=true"
import script from "./ClientDuplicateConfirmation.vue?vue&type=script&lang=js"
export * from "./ClientDuplicateConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ClientDuplicateConfirmation.vue?vue&type=style&index=0&id=6457ac54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6457ac54",
  null
  
)

export default component.exports